import React from 'react';
import styled from 'styled-components';

import { ShippingEco, ShippingExpress } from '../../../Icon';
import { Timer } from './Timer';

type Props = {
  method: string;
};

type ShippingConfigOptsType = {
  [key: string]: {
    icon: Function;
    title: string;
    trackingDetails: string;
    caption: string;
    offer?: string;
  };
};

const ShippingConfigOpts: ShippingConfigOptsType = {
  air: {
    icon: ShippingExpress,
    title: 'Express Shipping via Air',
    trackingDetails: 'Priority Tracking & Support',
    caption: 'Expected shipping time 14 - 21 days',
  },
  sea: {
    icon: ShippingEco,
    title: 'Eco Shipping via Sea',
    trackingDetails: '',
    caption: 'Expected shipping time 5 weeks',
    offer: '',
  },
};

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 65px auto;
  width: 100%;
  grid-gap: 10px;
  color: #242325;
  align-items: center;
`;

const ShippingBody = styled.div`
  position: relative;
`;

const ShippingMethodTitle = styled.div`
  font: normal normal normal 14px/17px Lato;
  letter-spacing: 0;
  text-align: left;
`;

const ShippingMethodCaption = styled.div`
  font: normal normal 300 12px/20px Lato;
  letter-spacing: 0.24px;
  text-align: left;
`;

const ShippingOffer = styled.span`
  letter-spacing: 0.2px;
  background-color: #d14a0f;
  text-align: center;
  border-radius: 7px;
  color: #fff;
  padding: 1px 6px;
  font: normal normal bold 10px/20px Lato;
  margin-top: -12px;
  margin-right: -6px;
  float: right;
  text-transform: uppercase;
`;
const RuralFreightMessage = styled.span`
  text-align: left;
  font: normal normal 300 12px/15px Lato;
  letter-spacing: 0.24px;
  color: #d14a16;
  display: block;
  padding-top: 6px;
  text-transform: none;
`;

export const ShippingMethod = ({ method }: Props) => {
  const {
    title,
    icon: Icon,
    caption,
    offer,
    trackingDetails,
  } = ShippingConfigOpts[method];
  return (
    <Wrapper>
      <Icon />
      <ShippingBody>
        {offer && <ShippingOffer>{offer}</ShippingOffer>}
        <ShippingMethodTitle>{title}</ShippingMethodTitle>
        <ShippingMethodCaption>{trackingDetails}</ShippingMethodCaption>
        <ShippingMethodCaption>{caption}</ShippingMethodCaption>
        {method === 'sea' && <Timer />}
        {method === 'sea' && (
          <RuralFreightMessage>
            Rural areas may have an additional shipping charge. If addition
            shipping costs apply, we will provide a quote for shipping within 3
            days of the order being placed.
          </RuralFreightMessage>
        )}
      </ShippingBody>
    </Wrapper>
  );
};
